import { _UserData, UserData, UserDataBaseEnum } from "../../infra/storage/localStorage";
import { AuthenticationProps } from "../../view/authentication/authentication"

//import { useNavigate } from "react-router-dom";
export default class AuthenticationContainer {
  public props: AuthenticationProps;
  public searchParams: URLSearchParams
  public userData: UserData
  //public navigate = useNavigate();

  constructor(props: AuthenticationProps, searchParams: URLSearchParams) {
    this.searchParams = searchParams;
    this.userData = _UserData

    this.props = props
  }

  async LoginByToken(callBackOnFailure?: () => void, reportError: boolean = true) {
    const rawQuery = window.location.search;
    const tokenMatch = rawQuery.match(/[?&]token=([^&]*)/);
    let token = tokenMatch ? decodeURIComponent(tokenMatch[1]) : null;

    if (token == null) {
      // Prefer TokenAES for re-authentication — byToken expects the AES-encrypted token, not the JWT
      token = this.userData.Get(UserDataBaseEnum.TokenAES) || this.userData.Get(UserDataBaseEnum.Token)
    }

    this.props.LoginByToken(token, reportError)

    if (token == undefined || token == null) {
      if (callBackOnFailure) callBackOnFailure()
    }
  }
}
